module.exports = __webpack_public_path__ + "static/img/Down-Arrow@2x.a7b29f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/detail/Down-Arrow@2x.png
// module id = amZ3
// module chunks = 10